module.exports = __webpack_public_path__ + "img/logo-school-5.32fc1030.png";